import moment from "moment"
import { adPlatOptions } from '../../goodsInfo/taobao/config'

export const renderList = [
	{
		label: '开始日期',
		key: 'startCreateDate',
		type: 'datePicker',
		placeholder: '请选择'
	},
	{
		label: '结束日期',
		key: 'endCreateDate',
		type: 'datePicker',
		placeholder: '请选择'
	},
	{
		label: '账户ID',
		key: 'advertiseId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '计划ID',
		key: 'planId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '客户',
		key: 'customerId',
		type: 'select',
		width: 160,
		isHide: true,
		placeholder: '请选择',
		options: []
	},
	{
		label: '引流平台',
		key: 'fromPlat',
		type: 'select',
		placeholder: '请选择',
		options: adPlatOptions
	}
]

export const renderMobileList = [
	{
		label: '选择日期',
		key: 'dates',
		type: 'rangePicker',
		placeholder: '请选择',
		maxInterval: 31,
		maxEndDate: new Date(moment(new Date()).format('YYYY-MM-DD')),
        minStartDate: new Date(moment(new Date()).subtract(2, 'year').format('YYYY-MM-DD'))
	},
	{
		label: '账户ID',
		key: 'advertiseId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '计划ID',
		key: 'planId',
		type: 'input',
		placeholder: '请输入',
		isRowEnd: true
	},
	{
		label: '客户',
		key: 'customerId',
		type: 'picker',
		placeholder: '请选择',
		isRowEnd: true,
		isHide: true,
		options: [],
		valueKey: 'label',
	},
	{
		label: '引流平台',
		key: 'fromPlat',
		type: 'picker',
		placeholder: '请选择',
		valueKey: 'label',
		options: [{ label: '无', value: undefined }, ...adPlatOptions]
	}
]



// WEBPACK FOOTER //
// ./src/pages/home/dataEffect/planData/config.js